export default __webpack_public_path__ + "static/exterior7wooden-a5fe8583f56539b3f97897bd12a6ef58.jpg";